import { createFileRoute } from '@tanstack/react-router';
import { candidatesQuery, candidateStatsQuery } from '@/features/candidates/api';
import { CandidatesPage } from '@/features/candidates/pages/CandidatesPage';
import { candidatesSearchSchema } from '@/features/candidates/search';
import { sourcesQuery } from '@/features/sources/api';

export const Route = createFileRoute('/_authed/ops/candidates/')({
  staticData: { help: 'candidates' },
  validateSearch: candidatesSearchSchema,
  loaderDeps: ({ search }) => search,
  loader: ({ context: { queryClient }, deps }) => {
    void queryClient.prefetchQuery(candidateStatsQuery());
    void queryClient.prefetchQuery(sourcesQuery());
    void queryClient.prefetchQuery(candidatesQuery(deps));
  },
  component: CandidatesPage,
});
